import React from 'react';
import Modal from 'react-bootstrap/Modal';

import './Style.css';

class ModalVariacoes extends React.Component {

    /**
     * Formata a data do período.
     *
     * Exemplo:
     * 2026-09-01 -> 09/2026
     */
    formatPeriod = (period) => {
        if (!period) {
            return '-';
        }

        const date = new Date(period);

        if (Number.isNaN(date.getTime())) {
            return period;
        }

        return date.toLocaleDateString(
            'pt-BR',
            {
                month: '2-digit',
                year: 'numeric',
            }
        );
    };

    render() {
        const {
            open,
            cityPeriod,
            loading,
            variations,
            onClose,
        } = this.props;

        if (!open) {
            return null;
        }

        return (
            <Modal
                show={open}
                onHide={onClose}
                dialogClassName="modal-variacoes"
                size="lg"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>
                        Variações do Período de { this.formatPeriod(cityPeriod?.period) }
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body>

                    {loading && (
                        <div className="text-center">
                            <i className="fa fa-spinner fa-spin"></i>
                        </div>
                    )}

                    {!loading && variations && (
                        <div
                            dangerouslySetInnerHTML={{
                                __html: variations,
                            }}
                        />
                    )}

                    {!loading && !variations && (
                        <div className="text-center">
                            Nenhuma informação encontrada.
                        </div>
                    )}

                </Modal.Body>

                <Modal.Footer>
                    <button
                        type="button"
                        className="btn btn-secondary"
                        onClick={onClose}
                    >
                        Fechar
                    </button>
                </Modal.Footer>

            </Modal>
        );
    }
}

export default ModalVariacoes;